module.exports = __webpack_public_path__ + "img/Home Page banner (Mobile).e30628f8.svg";